import { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  Accordion, Column, Heading, Spacer,
} from '@oliasoft-open-source/react-ui-library';
import { getTokenPayload } from '@oliasoft/pkce';
import { FeatureFlagsComponent, FeatureFlags, IFeatureFlag } from '@oliasoft/feature-flags';

import { updateFeatureFlag } from 'client/store/entities/feature-flags/feature-flags';
import { RootState } from 'client/store/configureStore';
import ClientConfig from 'client/config';

const FeatureFlagSettings = ({ updateFeatureFlag, customerName, featureFlagsInitialized }: IFeatureFlagProp) => {
  const [flags, setFlags] = useState<IFeatureFlag[]>([]);
  const tokenPayload = getTokenPayload(
    ClientConfig.config.pkce.provider,
    ClientConfig.config.applicationId,
    ClientConfig.config.idpServerUrl,
  );
  const subjectid = tokenPayload!.subjectId;

  useEffect(() => {
    if (featureFlagsInitialized) {
      setFlags(FeatureFlags.getFlags());
    }
  }, [featureFlagsInitialized]);

  const onChange = (state: boolean, featureFlagId: string, featureFlagName: string) => {
    updateFeatureFlag({ featureFlagId, state, customerName });
    FeatureFlags.setFlag(featureFlagName, state, subjectid);
    setFlags(FeatureFlags.getFlags());
  };

  return (
    <Column>
      <Spacer height="var(--padding-sm)" />
      <Accordion expanded heading={<Heading>Feature flags</Heading>} managed bordered padding={false}>
        <FeatureFlagsComponent featureFlags={flags} customerName={customerName} onChange={onChange} />
      </Accordion>
    </Column>
  );
};

const mapDispatchToProps = {
  updateFeatureFlag,
};

const mapStateToProps = ({ entities }: RootState) => ({
  customerName: entities.customer.selectedCustomer?.customerLabel as string,
  featureFlagsInitialized: !entities.featureFlags.isFetching,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type IFeatureFlagProp = ConnectedProps<typeof connector>;

const Container = connector(FeatureFlagSettings);

export { Container as FeatureFlagSettings };
